import LxcError from "~/core/models/LxcError.class";
import type { PkiCertificateAuthority } from "~/modules/pki/models/PkiCertificateAuthority.interface";
import pkiService from "~/modules/pki/services/pki.service";

export function useFetchPkiCertificateAuthorities() {
  const service = pkiService.getCertificateAuthorities.bind(pkiService);

  const isLoading = ref(false);
  const error: Ref<LxcError | null> = ref(null);
  const results: Ref<PkiCertificateAuthority[]> = ref([]);

  async function fetchPkiCertificateAuthorities() {
    isLoading.value = true;
    error.value = null;
    results.value = [];

    const response = await service();

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      results.value = response;
    }

    isLoading.value = false;
  }

  return {
    fetchPkiCertificateAuthorities,
    isLoading,
    error,
    results,
  };
}
